var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"focus:outline-none",class:_vm.clase,attrs:{"disabled":_vm.disabled || _vm.invalid},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }